import type { NudgeAccent } from "./types";

export const nudgeAccentStyles: Record<
  NudgeAccent,
  { icon: string; card: string }
> = {
  primary: {
    icon: "bg-primary/10 text-primary",
    card: "bg-primary/[0.03]",
  },
  warning: {
    icon: "bg-amber-500/10 text-amber-600 dark:text-amber-400",
    card: "bg-amber-500/[0.04]",
  },
  danger: {
    icon: "bg-destructive/10 text-destructive",
    card: "bg-destructive/[0.04]",
  },
  info: {
    icon: "bg-sky-500/10 text-sky-600 dark:text-sky-400",
    card: "bg-sky-500/[0.04]",
  },
};
